// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Kd7g","footer":"ReportModalFilter_footer__iid5W"};